import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import { NETWORK_LOGO_IMAGE, renderImage } from 'helpers/ImageHelper';
import style from './style.css';

const Item = (props = {}) => {
  const { image, label, link, color } = props;
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className={style.container}>
      <span className={style.extender} style={{ backgroundColor: color }} />
      <div className={style.content}>
        <div className={style.imageContainer}>
          {renderImage({
            src: image,
            imageType: NETWORK_LOGO_IMAGE,
            alt: label,
            className: style.image,
          })}
        </div>
        <div className={style.text}>{label}</div>
        <div className={style.iconContainer}>
          <Icon color="white" viewBox="0 0 24 24" icon="external-link-square-alt" size="small" />
        </div>
      </div>
    </a>
  );
};

Item.propTypes = {
  image: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

Item.defaultProps = {};

export default Item;
